import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=31fcdd5e"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fcdd5e')) {
      api.createRecord('31fcdd5e', component.options)
    } else {
      api.reload('31fcdd5e', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=31fcdd5e", function () {
      api.rerender('31fcdd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/ResetPassword.vue"
export default component.exports